<h1 mat-dialog-title i18n="Select lang dialog|title @@selectLangDialog.title">Изменить язык</h1>
<div mat-dialog-content>
  <mat-nav-list>
    @for (link of links; track link) {
      <a [class.selected]="isSelected(link)" mat-list-item href="/{{link}}" > {{ names[link] }} </a>
    }
  </mat-nav-list>
</div>
